import type { LucideIcon } from 'lucide-react';
import {
  Accessibility,
  Plus,
  Ruler,
  Scale,
  Shirt,
  UserRound,
} from 'lucide-react';
import type { PatientMeasurementField } from '../types';

export const BASE_FIELD_ICON_BY_LABEL = {
  Peso: Scale,
  Spalle: Accessibility,
  Fianchi: Ruler,
  Vita: Ruler,
  Petto: Shirt,
  Collo: UserRound,
  Coscia: Ruler,
  Polpacci: Ruler,
} as const;

export function getPatientMeasurementFieldIcon(
  field: PatientMeasurementField
): LucideIcon {
  if (field.scope === 'extra') {
    return Plus;
  }

  return (
    BASE_FIELD_ICON_BY_LABEL[
      field.label as keyof typeof BASE_FIELD_ICON_BY_LABEL
    ] ?? Accessibility
  );
}
